import { classes } from "../utilities";
import { componentClasses } from "../../components/icon/icon";
/**
 * Builds an SVG icon and returns the string version of it
 * @param {object} args - The SVG icon to be built
 * @param {string} args.class - The class of the SVG icon
 * @param {string} args.path - The path of the SVG icon
 * @returns {string} SVG as a string
 */
const buildSVGIcon = (args) => {
    const svgClasses = classes({
        [componentClasses.base]: true,
        [args.class]: args.class,
    });

    return `<svg class="${svgClasses}" viewBox="0 0 32 32" aria-hidden="true" focusable="false">${args.path}</svg>`;
};

export const arrowDown = (args) => {
    const path = `<path d="M 27.2 15.6 L 13.6 0 L 0 15.6 L 1.6 17.0 L 12.6 4.4 V 32 H 14.6 V 4.4 L 25.6 17.0 L 27.2 15.6 Z" />`;
    return buildSVGIcon({ ...args, path });
};

export const chevronDown = (args) => {
    const path = `<path d="M30.48 7.24l-14.48 14.48-14.48-14.48-1.52 1.52 16 16 16-16z"/>`;
    return buildSVGIcon({ ...args, path });
};

export const alertNotice = (args) => {
    const path = `<path d="M16 2.14l-16 27.72h32l-16-27.72zM16 6.14l12.48 21.6h-24.96l12.48-21.52zM14.96 24h2v2h-2zM14.96 12.1h2v10h-2z"/>`;
    return buildSVGIcon({ ...args, path });
};

export const calendar = (args) => {
    const path = `<path d="M10.74 13.24h4v2.12h-4zM17.3 13.24h4v2.12h-4zM23.84 13.24h4v2.12h-4zM4.2 18.92h4v2.12h-4zM10.74 18.92h4v2.12h-4zM17.3 18.92h4v2.12h-4zM23.84 18.92h4v2.12h-4zM4.2 24.58h4v2.14h-4zM10.74 24.58h4v2.14h-4zM22.96 2.42v-2.42h-2.14v2.42h-9.76v-2.42h-2.12v2.42h-8.94v29.58h32v-29.58zM8.96 4.54v1.88h2.1v-1.88h9.76v1.88h2.14v-1.88h6.9v3.46h-27.72v-3.46zM2.14 29.86v-19.76h27.72v19.76z"></path>`;
    return buildSVGIcon({ ...args, path });
};

export const check = (args) => {
    const path = `<path d="M11.86 26.12l-11.86-11.5 1.42-1.48 10.46 10.16 18.72-17.42 1.4 1.5z"/>`;
    return buildSVGIcon({ ...args, path });
};

export const chevronLeft = (args) => {
    const path = `<path d="M24.76 1.52l-1.52-1.52-16 16 16 16 1.52-1.52-14.48-14.48z"/>`;
    return buildSVGIcon({ ...args, path });
};

export const chevronRight = (args) => {
    const path = `<path d="M8.76 0l-1.52 1.52 14.48 14.48-14.48 14.48 1.52 1.52 16-16z"/>`;
    return buildSVGIcon({ ...args, path });
};

export const closeX = (args) => {
    const path = `<path d="M32 1.64l-1.64-1.64-14.36 14.4-14.36-14.3-1.64 1.64 14.3 14.26-14.2 14.26 1.64 1.74 14.26-14.3 14.26 14.3 1.64-1.64-14.3-14.36z"/>`;
    return buildSVGIcon({ ...args, path });
};

export const overflow = (args) => {
    const path = `<path d="M14.34 21.66h3.32v3.34h-3.32zM14.34 14.34h3.32v3.32h-3.32zM14.34 7h3.32v3.34h-3.32z"></path>`;
    return buildSVGIcon({ ...args, path });
};
export const arrowTriSolidStacked = (args) => {
    const path = `<path d="M16 0l-14.68 14.22h29.36zM30.68 17.78h-29.3l14.72 14.22z"/>`;
    return buildSVGIcon({ ...args, path });
};

export const skipToFront = (args) => {
    const path = `<path d="M25.2 0l-16.26 15.56v-15.56h-2.14v32h2.14v-15.56l16.26 15.56v-32zM23.060 27l-11.5-11 11.5-11z"/>`;
    return buildSVGIcon({ ...args, path });
};

export const arrowTriLeft = (args) => {
    const path = `<path d="M7.64 16l16.72 16v-32zM22.22 27l-11.5-11 11.5-11z"/>`;
    return buildSVGIcon({ ...args, path });
};

export const arrowTriRight = (args) => {
    const path = `<path d="M7.64 0v32l16.72-16zM9.78 5l11.5 11-11.5 11z"/>`;
    return buildSVGIcon({ ...args, path });
};

export const pin = (args) => {
    const path = `<path d="M19.82 0L16.22 3.54L16.94 7.08L12.14 11.82L7.2 9.12C6.83444 8.9153 6.4184 8.81822 6 8.82C5.38766 8.83494 4.79814 9.07218 4.36 9.5L1.18 12.72L9.32 20.72L0.32 29.88L0 32L2.12 31.64L11.12 22.54L19.12 30.4L22.38 27.18C22.7394 26.8356 22.974 26.3812 23.0464 25.8886C23.1188 25.396 23.025 24.8934 22.78 24.46L20 19.58L24.82 14.84L28.4 15.56L32 12L19.82 0ZM27.7 13.24L24.12 12.54L17.34 19.22L20.86 25.48C20.8798 25.5096 20.8904 25.5444 20.8904 25.58C20.8904 25.6156 20.8798 25.6504 20.86 25.68L19.12 27.38L4.24 12.72L6 11.02L12.52 14.46L19.3 7.78L19.06 6.66L18.58 4.24L19.82 3.02L28.94 12L27.7 13.22V13.24Z"/>`;
    return buildSVGIcon({ ...args, path });
};
export const unpin = (args) => {
    const path = `
        <path d="m 12.653055,11.363055 1.81,1.23 4.86,-4.7900003 -0.24,-1.12 -0.48,-2.42 1.24,-1.22 9.12,8.9800003 -1.24,1.22 v 0.02 l -3.58,-0.7 -3.95,3.89 1.8,1.22 2.85,-2.81 3.58,0.72 3.6,-3.56 -12.18,-12.00000025 -3.6,3.53999995 0.72,3.54 z" />
        <path d="m 20.083055,23.703055 -0.34,-0.24 1.14,2 c 0.0198,0.0296 0.0304,0.0644 0.0304,0.1 0,0.0356 -0.0106,0.0704 -0.0304,0.1 l -1.74,1.7 -14.0000003,-13.79002 -2.88,-1.9 -1.06,1.07 8.14,8.00002 -8.99999995,9.16 -0.32,2.12 2.11999995,-0.36 9.0000003,-9.1 8,7.86 3.26,-3.22 c 0.358,-0.3454 0.5934,-0.7984 0.67,-1.29 0,-0.06 0,-0.13 0,-0.19 z" />
        <path d="M 19.763055,21.023055 0.02305475,7.7230547 l 1.15999995,-1.7 30.8400003,20.8200003 -1.16,1.7 -9.72,-6.52 z" />
    `;
    return buildSVGIcon({ ...args, path });
};

export const skipToEnd = (args) => {
    const path = `<path d="M23.060 0v15.56l-16.26-15.56v32l16.26-15.56v15.56h2.14v-32zM8.94 27v-22l11.5 11z"/>`;
    return buildSVGIcon({ ...args, path });
};

export const alertCheckCir = (args) => {
    const path = `<path d="M8.52 14.58l-1.46 1.42 6.52 6.34 18.42-18.22-1.48-1.48-16.96 16.84zM28.82 12.76c0.262 0.967 0.421 2.081 0.44 3.229l0 0.011c0 7.5-6.080 13.58-13.58 13.58s-13.58-6.080-13.58-13.58c0-7.5 6.080-13.58 13.58-13.58v0c2.748 0.004 5.302 0.832 7.429 2.251l-0.049-0.031 1.54-1.52c-2.477-1.752-5.559-2.8-8.886-2.8-0.012 0-0.024 0-0.036 0h0.002c-0.017-0-0.038-0-0.058-0-8.693 0-15.74 7.047-15.74 15.74s7.047 15.74 15.74 15.74c8.693 0 15.74-7.047 15.74-15.74 0-1.796-0.301-3.522-0.855-5.131l0.033 0.111-1.72 1.72z"/>`;
    return buildSVGIcon({ ...args, path });
};
